import { render, staticRenderFns } from "./EventReg.vue?vue&type=template&id=2c08d480&scoped=true"
import script from "./EventReg.vue?vue&type=script&lang=js"
export * from "./EventReg.vue?vue&type=script&lang=js"
import style0 from "./EventReg.vue?vue&type=style&index=0&id=2c08d480&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c08d480",
  null
  
)

export default component.exports